import React, { useRef } from "react";
// import "./WinnersLand.css";
import {
  ArrowLeft,
  ArrowRight,
  Building2,
  MapPin,
} from "lucide-react";

import heroImg from "../../../Images/hero-villa.jpg";
import cityImg from "../../../Images/city-skyline.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";
import towerImg from "../../../Images/property-tower.jpg";


// function WinnersTopProjects() {
//   const trackRef = useRef(null);

//   const scroll = (dir) => {
//     const el = trackRef.current;
//     if (!el) return;

//     el.scrollBy({
//       left: dir * el.clientWidth * 0.6,
//       behavior: "smooth",
//     });
//   };

//   const projects = [
//     {
//       title: "The Sand Residences",
//       desc: "92 curated suites with private terraces",
//       price: "₹2.4 Cr",
//       type: "Luxury Apartment",
//       loc: "Gurgaon Sector 65",
//       img: towerImg,
//     },
//     {
//       title: "Aurum Vistas",
//       desc: "Sky-villas with panoramic city views",
//       price: "₹4.8 Cr",
//       type: "Penthouse",
//       loc: "Lucknow Hazratganj",
//       img: heroImg,
//     },
//     {
//       title: "Linea Quartier",
//       desc: "Mid-rise community with green commons",
//       price: "₹1.6 Cr",
//       type: "Residence",
//       loc: "Noida Extension",
//       img: interiorImg,
//     },
//     {
//       title: "Maison Dwarka",
//       desc: "Boutique low-rise homes near the metro",
//       price: "₹3.1 Cr",
//       type: "Boutique Villa",
//       loc: "Dwarka Sector 22",
//       img: cityImg,
//     },
//   ];

//   return (
//     <section className="ws-top">
//       {/* same JSX from original component */}
//     </section>
//   );
// }

// export default WinnersTopProjects;

export function WinnersTopProjects() {
  const trackRef = useRef(null);

  const scroll = (dir) => {
    const el = trackRef.current; if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.6, behavior: "smooth" });
  };
  const projects = [
    { title: "The Sand Residences", desc: "92 curated suites with private terraces", price: "₹2.4 Cr", type: "Luxury Apartment", loc: "Gurgaon Sector 65", img: towerImg },
    { title: "Aurum Vistas", desc: "Sky-villas with panoramic city views", price: "₹4.8 Cr", type: "Penthouse", loc: "Lucknow Hazratganj", img: heroImg },
    { title: "Linea Quartier", desc: "Mid-rise community with green commons", price: "₹1.6 Cr", type: "Residence", loc: "Noida Extension", img: interiorImg },
    { title: "Maison Dwarka", desc: "Boutique low-rise homes near the metro", price: "₹3.1 Cr", type: "Boutique Villa", loc: "Dwarka Sector 22", img: cityImg },
  ];

  return (
    <section className="ws-top">
      <div className="ws-top-inner">
        <div className="ws-top-head">
          <div>
            <span className="ws-section-eyebrow">Highlighted projects</span>
            <h2 className="ws-section-heading">Premium investments crafted for future living.</h2>
          </div>
          <div>
            <p>Handpicked real estate projects with modern architecture, premium amenities and prime
              city locations — ready for you to discover, visit and own.</p>
            <div className="ws-top-nav">
              <button className="ws-nav-btn" onClick={() => scroll(-1)} aria-label="Previous"><ArrowLeft size={18} /></button>
              <button className="ws-nav-btn" onClick={() => scroll(1)} aria-label="Next"><ArrowRight size={18} /></button>
            </div>
          </div>
        </div>

        <div className="ws-top-track" ref={trackRef}>
          {projects.map((p) => (
            <article className="ws-top-card" key={p.title}>
              <div className="ws-top-img">
                <img src={p.img} alt={p.title} loading="lazy" width={800} height={500} />
                <span className="ws-top-tag">Featured</span>
              </div>
              <div className="ws-top-body">
                <div className="ws-top-row">
                  <div>
                    <h3>{p.title}</h3>
                    <p>{p.desc}</p>
                  </div>
                  <div className="ws-top-price">
                    <span>Starting</span>
                    <strong>{p.price}</strong>
                  </div>
                </div>
                <div className="ws-top-meta">
                  <div className="ws-top-meta-item">
                    <Building2 size={18} />
                    <div><span>Type</span><p>{p.type}</p></div>
                  </div>
                  <div className="ws-top-meta-item">
                    <MapPin size={18} />
                    <div><span>Location</span><p>{p.loc}</p></div>
                  </div>
                </div>
                <div className="ws-top-footer">
                  <button>Explore project</button>
                  <button>View details</button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}